import { getPlaceholderPhoto } from 'utils/get-placeholder-photo';

const placeholderAnnouncementDog = {
    header: 'We are now offering a pet concierge program',
    description: "We're excited to introduce our new Pet Concierge Program, designed to make pet care easier and more convenient for you. From grooming to walking and beyond, we've got your furry friends covered!",
    imageUrls: [getPlaceholderPhoto('placeholder-dog.jpg')],
    startDate: new Date().toISOString(),
    startTime: '10:00',
    duration: '1 hour',
    isManuallyRemoved: true,
  };
  
  const placeholderAnnouncementCat = {
    header: 'We are now offering a pet concierge program',
    description: "We're excited to introduce our new Pet Concierge Program, designed to make pet care easier and more convenient for you. From grooming to walking and beyond, we've got your furry friends covered!",
    imageUrls: [getPlaceholderPhoto('placeholder-cat.png')],
    startDate: new Date().toISOString(),
    startTime: '10:00',
    duration: '1 hour',
    isManuallyRemoved: true,
  };
  
  const placeholderAnnouncementCity = {
    header: 'We are now offering a pet concierge program',
    description: "We're excited to introduce our new Pet Concierge Program, designed to make pet care easier and more convenient for you. From grooming to walking and beyond, we've got your furry friends covered!",
    imageUrls: [getPlaceholderPhoto('placeholder-city.jpg')],
    startDate: new Date().toISOString(),
    startTime: '10:00',
    duration: '1 hour',
    isManuallyRemoved: true,
  };
  
  const placeholderCalendarEvent = {
    name: 'Event Name',
    description: 'We are going to do some stretching for better start of the day',
    place: '1st Floor',
    capacity: 10,
    taken: 4,
    cost: 0,
    clientAvatars: [],
    date: 'Tue, 22 Apr 2025 18:45:00 GMT',
    image: 'placeholder-event.jpg',
    timezone: 'America/Chicago',
  }

  const placeholderCalendarEvent2 = {
    name: 'Event Name',
    description: 'We are going to do some stretching for better start of the day',
    place: '1st Floor',
    capacity: 10,
    taken: 4,
    cost: 0,
    clientAvatars: [],
    date: 'Tue, 22 Apr 2025 18:45:00 GMT',
    image: 'placeholder-event-2.jpg',
    timezone: 'America/Chicago',
  }
  
  const placeholderNeighbourhoodPerk = {
    id: 1,
    name: 'Perk Name',
    tag: 'Free',
    image: 'placeholder-perk.jpg',
    logo: 'placeholder-perk-logo.png',
    category: 'Hotels',
    description: 'Lorem ipsum dolor sit amet consectetur. Tincidunt elementum suscipit consectetur elit dignissim sapien aenean. Sit consectetur blandit at leo lectus arcu arcu. Urna est sed morbi pretium et netus rhoncus. Eget sed elementum quam ultrices volutpat tellus in etiam commodo. Id non nulla morbi lectus ipsum. A pretium porttitor enim ac purus non sceleris...',
    promoCode: 'https://redvike.com/',
    link: null,
    buildingId: 30,
  };

  
  export { placeholderAnnouncementDog, placeholderAnnouncementCat, placeholderAnnouncementCity, placeholderCalendarEvent, placeholderCalendarEvent2, placeholderNeighbourhoodPerk };